module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "disabled": _vm.disabled,
      "value": _vm.getValue(),
      "hide-details": ""
    },
    on: {
      "input": function (val) { return _vm.changeValue(val); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606158c5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-common/components/DurationView.vue
// module id = 398
// module chunks = 1